import {
  CheckIcon,
  CloudIcon,
  CloudOffIcon,
  RefreshCwIcon,
  TriangleAlertIcon,
  type LucideIcon,
} from 'lucide-react'

export interface SyncStatusFlags {
  isOnline: boolean
  isSyncing: boolean
  pendingCount: number
  failedCount: number
}

export interface SyncStatusMeta {
  icon: LucideIcon
  colorClass: string
  text: string
  spin?: boolean
  /**
   * Set only when `text` carries a number the icon cannot express. Compact
   * surfaces (the drawer's sync row) show the label only in that case and
   * otherwise let the icon speak; the dialog always shows `text`.
   */
  count?: number
}

/** One vocabulary for sync state — shared by the sync dialog and the mobile
    drawer's sync row so they never drift apart. */
export const getSyncStatusMeta = ({
  isOnline,
  isSyncing,
  pendingCount,
  failedCount,
}: SyncStatusFlags): SyncStatusMeta => {
  if (!isOnline) return { icon: CloudOffIcon, colorClass: 'text-muted-foreground', text: 'Offline' }
  if (isSyncing)
    return { icon: RefreshCwIcon, colorClass: 'text-primary', text: 'Syncing...', spin: true }
  if (failedCount > 0)
    return { icon: TriangleAlertIcon, colorClass: 'text-destructive', text: 'Sync Failed' }
  if (pendingCount > 0)
    return {
      icon: CloudIcon,
      colorClass: 'text-warning',
      text: `${pendingCount} Pending`,
      count: pendingCount,
    }
  return { icon: CheckIcon, colorClass: 'text-success', text: 'Synced' }
}
